import styles from './FJMotionControlPresetList.module.less';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJHorizontalScrollArrow from '../../../../common/components/FJTab/FJHorizontalScrollArrow.jsx';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import { MOTION_CONTROL_PRESET_LIST } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJAIVideoGeneratorConfig from '../../../../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJImage from '../../../../common/components/FJImage/FJImage.jsx';
import { useState, useRef, useEffect } from 'react';
import FJVideoPreview from './FJVideoPreview.jsx';
import FJVersionConfig from '../../../../config/FJVersionConfig.js';
const FJMotionControlPresetList = props => {
    const { onItemClick } = props;
    const [temporaryVideo, setTemporaryVideo] = useState(null);
    const hoverTimer = useRef(null);

    const _onItemClick = (e, item) => {
        e.stopPropagation();
        onItemClick && onItemClick(item);
    };
    const onMouseEnter = item => {
        if (hoverTimer.current) {
            clearInterval(hoverTimer.current);
            hoverTimer.current = null;
        }
        hoverTimer.current = setTimeout(() => {
            setTemporaryVideo(item);
            clearTimeout(hoverTimer.current);
        }, 200);
    };
    useEffect(() => {
        return () => {
            clearInterval(hoverTimer.current);
        };
    }, []);
    const onMouseLeave = () => {
        clearInterval(hoverTimer.current);
        hoverTimer.current = null;
        setTemporaryVideo(null);
    };

    return (
        <div className={styles.preset_box}>
            <div className={styles.preset_title}>{FJLocalStore._('no-inspiration-try-these-styles')}</div>
            <FJHorizontalScrollArrow
                className={styles.preset_list_box}
                leftButtonStyle={{ left: '0' }}
                rightButtonStyle={{ right: '0' }}
            >
                <div className={styles.preset_list}>
                    {MOTION_CONTROL_PRESET_LIST.map(item => {
                        return (
                            <FJHoverBoardGradation
                                key={item.id}
                                isShowInBorder={true}
                                className={styles.preset_item_img_box}
                                onClick={e => _onItemClick(e, item)}
                                onMouseEnter={() => onMouseEnter(item)}
                                onMouseLeave={() => onMouseLeave()}
                            >
                                <FJImage
                                    imgSrc={
                                        FJAIVideoGeneratorConfig.motionControlPreviewPath +
                                        item.preImage +
                                        '?v=' +
                                        FJVersionConfig.staticPathVersion
                                    }
                                    loading='lazy'
                                    imgClassName={styles.preset_item_img}
                                />
                            </FJHoverBoardGradation>
                        );
                    })}
                </div>
            </FJHorizontalScrollArrow>
            <div className={`${styles.modal_view} ${temporaryVideo ? styles.visible : styles.hidden}`}>
                {temporaryVideo && (
                    <FJVideoPreview
                        className={styles.modal_view_video}
                        url={
                            FJAIVideoGeneratorConfig.motionControlPreviewPath +
                            temporaryVideo.previewVideo +
                            '?v=' +
                            FJVersionConfig.staticPathVersion
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default FJMotionControlPresetList;
FJMotionControlPresetList.propTypes = {
    dancePresetList: PropTypes.array,
    onItemClick: PropTypes.func,
};
